import { useEffect, useState } from 'react';

export default function useOverflowDetector(ref) {
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      setHasOverflow(el.scrollHeight > el.clientHeight);
    };

    // initial check
    check();

    // observe size changes (works if container or children resize)
    let ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(check);
      ro.observe(el);
      // also observe children: some browsers update when child sizes change;
      // observing the element usually covers it, but if not, observe children too:
      Array.from(el.children).forEach(child => ro.observe(child));
    } else {
      // fallback for old browsers
      window.addEventListener('resize', check);
    }

    // observe DOM mutations (content added/removed)
    const mo = new MutationObserver(check);
    mo.observe(el, { childList: true, subtree: true, characterData: true });

    // cleanup
    return () => {
      if (ro) {
        try {
          ro.disconnect();
        } catch {}
      } else {
        window.removeEventListener('resize', check);
      }
      try { mo.disconnect(); } catch {}
    };
  }, [ref]);

  return hasOverflow;
}
